import { render, staticRenderFns } from "./CookieControl.vue?vue&type=template&id=a8917162&scoped=true"
import script from "./CookieControl.vue?vue&type=script&lang=js"
export * from "./CookieControl.vue?vue&type=script&lang=js"
import style0 from "./CookieControl.vue?vue&type=style&index=0&id=a8917162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8917162",
  null
  
)

export default component.exports